import React from 'react';
import _ from 'lodash';
import {Grid, Form} from 'semantic-ui-react';
import {
  TextBoxField,
  RadioField,
  Checkbox,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {
  RADIO_OPTIONS,
  STRUCTRE_INSURANCE_OPTIONS,
} from 'go/components/dynamic/modules/projectSiteInventory/constants';
import {
  isLocationBuildingInventoryType,
  isVacantLandInventoryType,
} from 'go/components/dynamic/modules/projectSiteInventory/utils';

export class InsuranceInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allActs: {},
      validation: this.props.validation,
    };
  }

  handleCheckbox = (name, value) => {
    const arg = {target: {name, value}};
    this.props.handleChange(arg);
  };

  render() {
    if (
      this.props === undefined ||
      this.props.inventoryItem.projectSiteInventory === undefined ||
      this.props.inventoryItem.payload === undefined ||
      this.props.inventoryItem.payload.insurance === undefined ||
      this.props.inventoryItem.payload.repetitiveLoss === undefined
    )
      return <p>No data available</p>;

    const {insurance, repetitiveLoss} = this.props.inventoryItem.payload;
    const {displayType, locationType} = this.props;
    const isBuilding = isLocationBuildingInventoryType(locationType);
    const isVacantLand = isVacantLandInventoryType(locationType);
    const displayLabel = isVacantLand
      ? 'Is this vacant land insured?'
      : 'Is this structure insured?';
    return (
      <div id="insurance-section">
        <Grid>
          <Grid.Row>
            <Grid.Column mobile={16} computer={8}>
              <div id="structure-insured">
                <div className="util--full-width ui form">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">{displayLabel}</p>
                      {insurance.propertyInsured ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="structure-insured-control"
                        label={displayLabel}
                        title="Required: {displayLabel}"
                        name="payload.insurance.propertyInsured"
                        value={insurance.propertyInsured}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError(
                          'payload.insurance.propertyInsured'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.insurance.propertyInsured',
                          `${displayLabel}`
                        )}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
          {insurance.propertyInsured && (
            <div className="insured_property indent_1">
              <Grid>
                <Grid.Row>
                  <Grid.Column mobile={16} computer={16}>
                    <div className="util--full-width ui form">
                      {isBuilding && (
                        <div id="nfip-insured">
                          {displayType === 'view' ? (
                            <React.Fragment>
                              <p className="label">
                                National Flood Insurance Program (NFIP)
                              </p>
                              {insurance.nfipInsured ? 'Yes' : 'No'}
                            </React.Fragment>
                          ) : (
                            <div className="util--full-width ui form" id="nfip-container">
                              <Checkbox
                                title="Required: NFIP?"
                                id="nfip-insured-control"
                                className="container select-all"
                                handleChange={(name, value) => {
                                  this.handleCheckbox(name, value);
                                }}
                                handleBlur={this.props.handleBlur}
                                label={STRUCTRE_INSURANCE_OPTIONS.nfip}
                                checked={insurance.nfipInsured}
                                name="payload.insurance.nfipInsured"
                                disabled={false}
                              />
                            </div>
                          )}
                          {insurance.nfipInsured && (
                            <div className="nfip indent_1">
                              <Grid>
                                <Grid.Row>
                                  <Grid.Column mobile={16} computer={16}>
                                    <div id="nfip-policy-number">
                                      {displayType === 'view' ? (
                                        <React.Fragment>
                                          <p className="label">NFIP policy number</p>
                                          {insurance.nfipPolicyNumber}
                                        </React.Fragment>
                                      ) : (
                                        <div className="util--full-width ui form">
                                          <TextBoxField
                                            id="nfip-policy-number-control"
                                            label="NFIP policy number"
                                            title="Required: NFIP policy number"
                                            name="payload.insurance.nfipPolicyNumber"
                                            fluid
                                            value={insurance.nfipPolicyNumber}
                                            handleChange={
                                              this.props.handleChangeSpecialChar
                                            }
                                            handleBlur={this.props.handleBlur}
                                            displayError={this.props.displayError(
                                              'payload.insurance.nfipPolicyNumber'
                                            )}
                                            errorMessages={this.props.getErrorMessage(
                                              'payload.insurance.nfipPolicyNumber',
                                              'NFIP policy number'
                                            )}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </div>
                          )}
                        </div>
                      )}
                      <div id="private-insurance">
                        {displayType === 'view' ? (
                          <React.Fragment>
                            <p className="label">Private Insured</p>
                            {insurance.privateInsured ? 'Yes' : 'No'}
                          </React.Fragment>
                        ) : (
                          <div className="util--full-width ui form">
                            <Checkbox
                              name="payload.insurance.privateInsured"
                              title="Private Insured?"
                              id="private-insured"
                              className="container"
                              handleChange={(name, value) => {
                                this.handleCheckbox(name, value);
                              }}
                              handleBlur={this.props.handleBlur}
                              label={STRUCTRE_INSURANCE_OPTIONS.private}
                              checked={insurance.privateInsured}
                              disabled={false}
                            />
                          </div>
                        )}
                        {insurance.privateInsured && (
                          <div className="private-insured indent_1">
                            <Grid>
                              <Grid.Row>
                                <Grid.Column mobile={16} computer={16}>
                                  <div id="other-company-name">
                                    {displayType === 'view' ? (
                                      <React.Fragment>
                                        <p className="label">
                                          Company name{' '}
                                          <span>{isVacantLand ? 'Optional' : null}</span>
                                        </p>
                                        {insurance.otherCompanyName}
                                      </React.Fragment>
                                    ) : (
                                      <div className="util--full-width ui form">
                                        <TextBoxField
                                          id="other-company-name-control"
                                          label="Company name"
                                          title={
                                            isVacantLand
                                              ? 'Optional: Company name'
                                              : 'Required: Company name'
                                          }
                                          optional={isVacantLand ? true : false}
                                          name="payload.insurance.otherCompanyName"
                                          value={insurance.otherCompanyName}
                                          handleChange={this.props.handleChange}
                                          handleBlur={this.props.handleBlur}
                                          displayError={this.props.displayError(
                                            'payload.insurance.otherCompanyName'
                                          )}
                                          errorMessages={this.props.getErrorMessage(
                                            'payload.insurance.otherCompanyName',
                                            'Company name'
                                          )}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </div>
                        )}
                      </div>
                      <div id="self-insurance">
                        {displayType === 'view' ? (
                          <React.Fragment>
                            <p className="label">Self Insured</p>
                            {insurance.selfInsured ? 'Yes' : 'No'}
                          </React.Fragment>
                        ) : (
                          <div className="util--full-width ui form">
                            <Checkbox
                              className="container"
                              name="payload.insurance.selfInsured"
                              label={STRUCTRE_INSURANCE_OPTIONS.self}
                              title="self-insured"
                              id="self-insured"
                              handleChange={(name, value) => {
                                this.handleCheckbox(name, value);
                              }}
                              handleBlur={this.props.handleBlur}
                              checked={insurance.selfInsured}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {insurance.propertyInsured &&
              !insurance.nfipInsured &&
              !insurance.privateInsured &&
              !insurance.selfInsured ? (
                <div className="errorMessages">
                  {this.props.getErrorMessage('payload.insurance.privateInsured', '')}
                </div>
              ) : null}
            </div>
          )}
          {isBuilding && insurance.propertyInsured && insurance.nfipInsured && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <div id="repetitive-loss-structure">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Is this a repetitive loss structure?</p>
                      {repetitiveLoss.structure ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="repetitive-loss-structure-control"
                        label="Is this a repetitive loss structure?"
                        title="payload.repetitiveLoss.structure"
                        name="payload.repetitiveLoss.structure"
                        value={repetitiveLoss.structure}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError(
                          'payload.repetitiveLoss.structure'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.repetitiveLoss.structure',
                          'Is this a repetitive loss structure?'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
          {isBuilding && insurance.propertyInsured && insurance.nfipInsured && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <div id="severe-repetitive-loss-structure">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Is this a severe repetitive loss structure?</p>
                      {repetitiveLoss.severe ? 'Yes' : 'No'}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <RadioField
                        id="severe-repetitive-loss-structure-control"
                        label="Is this a severe repetitive loss structure?"
                        title="payload.repetitiveLoss.severe"
                        name="payload.repetitiveLoss.severe"
                        value={repetitiveLoss.severe}
                        handleChange={this.props.handleChangeBoolean}
                        handleBlur={this.props.handleBlur}
                        options={RADIO_OPTIONS}
                        displayError={this.props.displayError(
                          'payload.repetitiveLoss.severe'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.repetitiveLoss.severe',
                          'Is this a repetitive loss structure?'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
          {isBuilding && (repetitiveLoss.structure || repetitiveLoss.severe) && (
            <Grid.Row>
              <Grid.Column mobile={16} computer={8}>
                <div id="property-locator-number">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Repetitive loss property locator number</p>
                      {repetitiveLoss.propertyLocatorNumber}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      <TextBoxField
                        id="property-locator-number-control"
                        label="Property locator number"
                        title="Required: Repetitive loss property locator number"
                        name="payload.repetitiveLoss.propertyLocatorNumber"
                        value={repetitiveLoss.propertyLocatorNumber}
                        handleChange={this.props.handleChange}
                        handleBlur={this.props.handleBlur}
                        displayError={this.props.displayError(
                          'payload.repetitiveLoss.propertyLocatorNumber'
                        )}
                        errorMessages={this.props.getErrorMessage(
                          'payload.repetitiveLoss.propertyLocatorNumber',
                          'Repetitive loss property locator number'
                        )}
                      />
                    </div>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </div>
    );
  }
}

export default InsuranceInformation;
